import { useState } from 'react';
import { Modal, Button } from '../ui';

type AddEnablerCardModalProps = {
    onConfirm: (title: string, description: string) => void;
    onClose: () => void;
};

/**
 * Opened by the "Add enabler card" button in the Plan page's Timeline toolbar (see
 * PlanTimelineToolbar/PlanPage.tsx). Asks for just a title and description — an Enabler card has
 * no priority, tree, or any other OST-derived field to collect (see EnablerCardItem, types.ts) —
 * then hands the trimmed values back to PlanPage's handleCreateEnablerCard, which creates the
 * card already placed on the Timeline canvas.
 */
export default function AddEnablerCardModal({ onConfirm, onClose }: AddEnablerCardModalProps) {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    const isValid = !!title.trim();

    const submit = () => {
        if (!isValid) return;
        onConfirm(title.trim(), description.trim());
    };

    return (
        <Modal title='New Enabler Card' onClose={onClose} closeOnOverlayClick>
            <div className='insight-add-form'>
                <label className='insight-field-label'>Title *</label>
                <input
                    className='insight-field-input'
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder='Enabler title'
                    autoFocus
                />

                <label className='insight-field-label'>Description</label>
                <textarea
                    className='insight-field-textarea'
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder='What does this enabler cover?'
                    rows={3}
                />
            </div>
            <div className='modal-actions'>
                <Button variant='secondary' onClick={onClose}>Cancel</Button>
                <Button variant='primary' onClick={submit} disabled={!isValid}>Add Enabler</Button>
            </div>
        </Modal>
    );
}
